import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from 'react-router-dom';

import './style.css';
import Contact from './views/contact';
import Members from './views/members';
import About from './views/about';
import Initiatives from './views/initiatives';
import Home from './views/home';
import Blog from './views/blog';
import Page from './views/page';
import Resources from './views/resources';
import BlogPost from './components/blogpost';
import ScrollToTop from './components/ScrollToTop'
import DrupalContentPage from './views/drupal'

import { initGA, logPageView } from './analytics'; // Import Google Analytics functions

const App = () => {
  useEffect(() => {
    initGA(); // Initialize Google Analytics on app load
  }, []);

  return (
    <Router>
      <PageTracker /> {/* Handles logging of page views */}
      <ScrollToTop />
      <Switch>
        <Route component={Contact} exact path="/contact" />
        <Route component={Members} exact path="/members" />
        <Route component={Resources} exact path="/resources" />
        <Route component={About} exact path="/about" />
        <Route component={Initiatives} exact path="/initiatives" />
        <Route component={Home} exact path="/" />
        <Route component={Blog} exact path="/blog" />
        <Route path="/blog/:id" component={BlogPost} />
        <Route component={DrupalContentPage} exact path="/DrupalContentPage"/>
        <Route component={Page} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  );
};

// Component to log page views whenever the route changes
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(); // Log pageview when location (route) changes
  }, [location]);

  return null;
};

ReactDOM.render(<App />, document.getElementById('app'));
